var map = {
	"./account--icon.svg": "99100",
	"./developers--icon.svg": "609e",
	"./directory--icon.svg": "929c",
	"./documents--icon.svg": "26de",
	"./folios--icon.svg": "5a03",
	"./metrics--icon.svg": "b8a0",
	"./notifications--icon.svg": "a7eb",
	"./pos--icon.svg": "b026",
	"./purchases--icon.svg": "4743",
	"./reports--icon.svg": "c318",
	"./sii--icon.svg": "06e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c68";